import { Pipe, PipeTransform } from '@angular/core';
import {FieldStore}            from '../../stores/farm/field.store';
import {TranslationStore}      from '../../stores/translation/translation.store';

@Pipe({
  name: 'apGetFieldNamePipe',
})
export class ApGetFieldNamePipe implements PipeTransform {

  constructor(private fieldStore: FieldStore,
              private translationStore: TranslationStore) {
  }

  transform(id: string): string {
    const result = this.fieldStore.getFieldName(this.fieldStore.getFieldById(id));
    if (result === '-') {
      return this.translationStore.FindTranslationForSelectedLanguage('Global__UnknownFieldName');
    }
    return result;
  }

}
